import React, { useState } from 'react';
import { BoxStyled, TypographyStyledHeader } from './style';
import { PhenoCriteria } from './phenoCriteria';
import { NavigationButtons } from '../../../shared/components/navigationButtons';
import { Button, Container, Modal } from '@mui/material';
import infoIcon from '../../../assets/icons/infoIcon.svg';
import { Tooltip } from './Tooltip';
import { ScreeningResult } from './screening';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../store/hooks';
import { metaDataSelector } from '../../../store/globalSelectors';

const Glim = () => {
  const {
    optedOptions: { routeArr }
  } = useAppSelector(metaDataSelector);
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const getNextRoute = () => {
    if (location.pathname === '/malnutrition-screening/glim/screening') {
      if (routeArr.length) return routeArr[0];
      else return '/summary';
    } else return '/malnutrition-screening/glim/screening';
  };

  return (
    <>
      <BoxStyled>
        <Container
          sx={{
            display: 'flex',
            flexDirection: 'row',
            padding: '0.9375rem'
          }}
        >
          <TypographyStyledHeader>
            {location.pathname !== '/malnutrition-screening/glim/screening'
              ? 'GLIM'
              : ''}
          </TypographyStyledHeader>

          <Button
            onClick={() => handleOpen()}
            sx={{ height: '1.25rem', minWidth: '1.25rem', padding: 0 }}
          >
            <img src={infoIcon} alt={'infoIcon'} />
          </Button>
        </Container>

        <Routes>
          <Route index element={<PhenoCriteria />} />
          <Route path="screening" element={<ScreeningResult />} />
        </Routes>
      </BoxStyled>
      <NavigationButtons nextDisabled={false} nextRoute={getNextRoute()} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Tooltip onClose={handleClose} />
      </Modal>
    </>
  );
};

export { Glim };
